import { Col, SegmentControl, Spinner2 } from 'components';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { UserItem } from './';

const Suggested = ({ handleClick }) => {
  const [suggestions, setSuggestions] = useState(null),
    [selected, setSelected] = useState(0),
    { t } = useTranslation(),
    navigate = useNavigate();

  useEffect(() => {
    getSuggestions();
  }, []);

  async function getSuggestions() {
    const res = await Api.post('/shoutouts/getSuggestions');
    if (!res) return;

    setSuggestions(res);
  }

  return (
    <Col noFlex marg="42px 0 0" center>
      {!suggestions ? (
        <Col noFlex centerAll>
          <Spinner2 />
        </Col>
      ) : (
        <Col wid="100%">
          <SegmentControl
            options={[t('common.athletes'), t('common.teams')]}
            selectedIdx={selected}
            handleSelect={setSelected}
            wid="358px"
            textStyle={{
              b2: true
            }}
            small
          />

          <Col
            marg="16px 0 0"
            pad="16px 0"
            scrollY
            wid="100%"
            ht="224px"
            noFlex
            start
            gap="12px"
            style={{ overflowX: 'hidden' }}
          >
            {selected
              ? suggestions.teams.map((x, i) => (
                  <UserItem key={i} item={x} pad={'0'} onClick={() => handleClick(x)} />
                ))
              : suggestions.athletes.map((x, i) => (
                  <UserItem key={i} item={x} pad={'0'} onClick={() => handleClick(x)} />
                ))}
          </Col>
        </Col>
      )}
    </Col>
  );
};

export default Suggested;
